import { EMPTY_OBJECT } from '../constants/common'
import { PROVIDER_ENTITY } from '../constants/entity'
import { USER_PROVIDER_PROFILE_OPTIONS_API_PARAMS } from '../constants/user'
import { getApi, patchApi, postApi, putApi } from '../utils/api'

export function createProvider(data) {
  return postApi({ data, endpoint: `/api/${PROVIDER_ENTITY.single}/` })
}

export function getProviderProfile({ id }) {
  return getApi({ endpoint: `api/${PROVIDER_ENTITY.single}/${id}/` })
}

export function updateProviderProfile({ data, id }) {
  return patchApi({ data, endpoint: `api/${PROVIDER_ENTITY.single}/${id}/` })
}

export function getProvidersOptions(params) {
  return getApi({
    endpoint: `/idwell-api/api/v3/${PROVIDER_ENTITY.single}/${PROVIDER_ENTITY.single}-options/`,
    params,
  })
}

export function getProviderProfileOptions(params) {
  return getProvidersOptions({
    ...params,
    ...USER_PROVIDER_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function searchContractors({
  apiConfig = EMPTY_OBJECT,
  archived = false,
  query,
}) {
  return getApi({
    ...apiConfig,
    endpoint: `/api/${PROVIDER_ENTITY.single}/live-search/`,
    params: { ...apiConfig.params, archived, query },
  })
}

export function updateProvidersTableConfig(data) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${PROVIDER_ENTITY.plural}/config/`,
  })
}

export function performProviderMassAction(data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/${PROVIDER_ENTITY.single}/${PROVIDER_ENTITY.plural}/mass-action/`,
  })
}

export function getProvidersEmailRecipients(data) {
  return postApi({
    data,
    endpoint: '/idwell-api/api/v3/contractor/contractors/email-recipients/',
  })
}

export function startProvidersExport(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/contractor/contractors/export/',
  })
}

export function checkIProvidersExportTask(id) {
  return getApi({ endpoint: `api/contractor-export-task/${id}/` })
}

export function loadProvidersExportFieldsList() {
  return getApi({ endpoint: 'api/contractor-export/fields-list/' })
}

export function getMappedCategoryOptions(params) {
  return getApi({ endpoint: 'api/mapped-category-options/', params })
}

export function getMappedBuildingOptions(params) {
  return getApi({ endpoint: 'api/mapped-building-options/', params })
}

export function getContractorMapping(id) {
  return getApi({ endpoint: `api/${PROVIDER_ENTITY.single}/${id}/mapping/` })
}
